class BuchhaendlerProfil extends HTMLElement {
  connectedCallback() {
    this.setElements();
    this.bindEvents();
    this.calculateInitialButtonMoreState();
    if(this.sindAppCallbacksAktiv) {
      this.appCallbackSetTitle(this, 'Buchhändler/-innen im Portrait');
    }
  }

  setElements() {
    this.overlay = this.querySelector('.lbh-overlay');
    this.overlayOeffnenButtonList = this.querySelectorAll('[data-overlay]');
    this.overlaySchliessenButtonList = this.querySelectorAll('[data-overlay-close]');
    this.buttonMore = this.querySelector('.lbh-review-more');
    this.textReviewElement = this.querySelector('.lbh-review-teaser');
    this.anzahlBewertungenElement = this.querySelector('.anzahl-bewertungen');
  }

  bindEvents() {
    this.overlayOeffnenButtonList.forEach((button) => {
      button.addEventListener('click', () => this.overlayInitialisieren())
    });
    this.overlaySchliessenButtonList.forEach((button) => {
      button.addEventListener('click', () => this.overlaySchliessen())
    });
    window.addEventListener('resize', () => this.calculateInitialButtonMoreState());

    document.addEventListener('total-bewertungen', (event) => this.displayTotalBewertungenCount(event.detail));
  }

  overlayInitialisieren() {
    this.overlay.showModal();
  }

  overlaySchliessen() {
    this.overlay.close();
  }

  calculateInitialButtonMoreState() {
    if (this.buttonMore && this.textReviewElement) {
      this.buttonMore.style.display = (this.textReviewElement.scrollHeight > this.textReviewElement.offsetHeight) ? 'block' : 'none';
    }
  }

  get sindAppCallbacksAktiv() {
    return this.dataset.appCallbacksActive === 'true';
  }

  displayTotalBewertungenCount(totalElements) {
    this.anzahlBewertungenElement.innerText = totalElements;
  }

  appCallbackSetTitle(parent, title) {
    this.sendCallback(this.createCallbackApp('setTitle', title), parent);
  }

  createCallbackApp(action, title) {
    const callbackApp = document.createElement('callback-app');
    callbackApp.setAttribute('callback', action);
    if(title) {
      const callbackParam = document.createElement('callback-param');
      callbackParam.setAttribute('title', title);
      callbackApp.appendChild(callbackParam);
    }
    return callbackApp;
  }

  sendCallback(element, parent) {
    parent.insertAdjacentElement("afterend", element);
  }
}

customElements.get("buchhaendler-profil") || customElements.define("buchhaendler-profil", BuchhaendlerProfil);
